import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const LegalConsentModal = ({ isOpen, onConfirm, onCancel }) => {
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeCookies, setAgreeCookies] = useState(false);

  if (!isOpen) return null;

  const canSubmit = agreeTerms && agreePrivacy && agreeCookies;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-xl">
        <h2 className="mb-2 text-lg font-semibold text-gray-900">Review and accept our policies</h2>
        <p className="mb-4 text-sm text-gray-600">
          To continue using the Platform, please review and accept the following:
        </p>

        <div className="space-y-3">
          <label className="flex items-start gap-3 text-sm text-gray-800">
            <input
              type="checkbox"
              className="mt-1"
              checked={agreeTerms}
              onChange={e => setAgreeTerms(e.target.checked)}
            />
            <span>
              I have read and agree to the{' '}
              <Link to="/terms" className="text-blue-600 hover:underline">
                Terms of Service
              </Link>
              .
            </span>
          </label>

          <label className="flex items-start gap-3 text-sm text-gray-800">
            <input
              type="checkbox"
              className="mt-1"
              checked={agreePrivacy}
              onChange={e => setAgreePrivacy(e.target.checked)}
            />
            <span>
              I acknowledge the{' '}
              <Link to="/privacy" className="text-blue-600 hover:underline">
                Privacy Policy
              </Link>
              .
            </span>
          </label>

          <label className="flex items-start gap-3 text-sm text-gray-800">
            <input
              type="checkbox"
              className="mt-1"
              checked={agreeCookies}
              onChange={e => setAgreeCookies(e.target.checked)}
            />
            <span>
              I understand the{' '}
              <Link to="/cookies" className="text-blue-600 hover:underline">
                Cookie Policy
              </Link>
              .
            </span>
          </label>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            className="rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={!canSubmit}
            className={`rounded-md px-4 py-2 text-sm font-semibold text-white ${
              canSubmit ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-300'
            }`}
            onClick={() =>
              onConfirm({ tosAccepted: true, privacyAccepted: true, cookiesAccepted: true })
            }
          >
            Accept and Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalConsentModal;
